// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.IconInvisible = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.IconInvisible = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var IconInvisible = _exports.IconInvisible = function IconInvisible(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M4.35907 8.20928C4.31344 8.27541 4.28844 8.35358 4.28722 8.43392C4.286 8.51425 4.30861 8.59315 4.35221 8.66064C4.69598 9.19882 5.10047 9.70417 5.55704 10.1529M15.6002 8.20801C15.6428 8.27417 15.6654 8.35119 15.6654 8.42988C15.6654 8.50856 15.6428 8.58558 15.6002 8.65175C14.3697 10.5788 12.3253 12.0871 9.96745 12.0871C8.25091 12.0871 6.73165 11.3074 5.55704 10.1529M5.55704 10.1529L3.93164 10.7028M8.03323 11.7465L7.19513 13.1031M11.9443 11.7465L12.8713 13.1031M14.3812 10.1529L15.9316 10.7028",
      stroke: "currentColor",
      "stroke-width": "0.928856",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }));
  };
});
